<template>
  <transition name="slide-down">
    <div class="modal-mask" v-show="$store.state.showDonate">
      <div class="modal-wrapper">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content" v-click-outside="closeModal">
            <button
              class="close"
              aria-label="Close"
              @click.prevent="closeModal"
            >
              <span aria-hidden="true"><i class="fe fe-x"></i></span>
            </button>
            <div class="justify-content-center">
              <div class="modal-header full-width">
                <form id="search" class="full-width">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text pr-0 border-right-0">
                        <i class="fe fe-search" id="searchAddon"></i>
                      </span>
                    </div>
                    <search-box
                      :query="searchQuery"
                      @input="onSearchInput"
                      @search="performSearch"
                      input-class="form-control pl-2 border-left-0"
                      placeholder="Type an organization name or category"
                      aria-label="Type an organization name or category"
                      aria-describedby="searchAddon"
                      :is-search-stalled="isLoading"
                    />
                  </div>
                </form>
              </div>
            </div>
            <div class="modal-body" id="items" ref="items">
              <categories />
              
              <search-results :hits="searchResults.hits" :is-loading="isLoading">
                <template v-slot="{ items }">
                  <div class="mt-5">
                    <organization-card
                      :item="item"
                      v-for="item in items"
                      :key="item.id"
                    />
                  </div>
                </template>
              </search-results>

              <div class="container text-center organizations-list">
                <app-loading-indicator :is-loading="isLoading" />
                <pagination
                  :current-page="searchResults.currentPage"
                  :total-pages="searchResults.totalPages"
                  @page-change="onPageChange"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import { EventBus } from "../event-bus.js";
import SearchService from "../services/searchService";
import SearchBox from "../components/SearchBox";
import SearchResults from "../components/SearchResults";
import Pagination from "../components/Pagination";
import OrganizationCard from "../components/OrganizationCard";
import Categories from "../components/Categories";
import AppLoadingIndicator from "../components/LoadingIndicator";

export default {
  name: "Home",
  components: {
    SearchBox,
    SearchResults,
    Pagination,
    OrganizationCard,
    AppLoadingIndicator,
    Categories,
  },
  
  data() {
    return {
      searchQuery: "",
      searchResults: {
        hits: [],
        totalHits: 0,
        currentPage: 0,
        totalPages: 0,
      },
      isLoading: false,
      searchDebounce: null,
    };
  },
  
  mounted() {
    let self = this;
    EventBus.$on("clearSearch", function () {
      self.searchQuery = "";
      self.searchResults = {
        hits: [],
        totalHits: 0,
        currentPage: 0,
        totalPages: 0,
      };
    });
    
    // Perform initial search
    this.performSearch();
  },
  
  computed: {
    filters() {
      return this.$store.state.country + "_code > 0  AND active:true";
    },
  },
  
  methods: {
    async performSearch(query = this.searchQuery, page = 0) {
      this.isLoading = true;
      
      try {
        const limit = 12;
        const offset = page * limit;
        
        const results = await SearchService.search(query, {
          filter: this.filters,
          limit,
          offset,
        });
        
        this.searchResults = results;
      } catch (error) {
        console.error('Search failed:', error);
        this.searchResults = {
          hits: [],
          totalHits: 0,
          currentPage: 0,
          totalPages: 0,
        };
      } finally {
        this.isLoading = false;
      }
    },
    
    onSearchInput(query) {
      this.searchQuery = query;
      
      // Debounce search
      if (this.searchDebounce) {
        clearTimeout(this.searchDebounce);
      }
      
      this.searchDebounce = setTimeout(() => {
        this.performSearch(query, 0);
      }, 300);
    },
    
    closeModal() {
      this.$store.state.showDonate = false;
      EventBus.$emit("clearSearch");
      this.searchQuery = "";
    },
    
    onPageChange(page) {
      this.performSearch(this.searchQuery, page);
      document.getElementById("items").scrollTo({
        top: 0,
        behavior: "smooth",
      });
      if (!this.$store.state.showDonate) {
        this.$nextTick(function () {
          window.scrollTo({
            top: document.querySelector(".organizations-list").offsetTop - 60,
            left: 0,
            behavior: "smooth",
          });
        });
      }
    },
  },
};
</script>
<style lang="scss">
#search {
  .input-group-prepend span {
    border-radius: 50px 0 0 50px;
  }
  input,
  .input-group-text {
    border-color: #900909;
  }
  .spinner {
    position: absolute;
    top: 13px;
    right: 17px;
  }
  .search-box-container {
    width: calc(100% - 40px);
    input {
      border-radius: 0 50px 50px 0;
    }
  }
}
.pagination {
  justify-content: center;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: block;
  transition: all 0.3s ease;
}

.modal-wrapper {
  display: block;
  z-index: 9999;
}
.modal-body {
  max-height: calc(100vh - 110px);
  overflow: auto;
  z-index: 10000;
}
.modal-dialog {
  height: calc(100vh - 20px);
}
.modal-content {
  height: 100%;
}
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s;
}
.slide-down-enter,
.slide-down-leave-to {
  opacity: 0;
  transform: translateY(-100vh);
}
button.close {
  padding: 0;
  background-color: #fff !important;
  border: 0;
  opacity: 1 !important;
  border-radius: 20px;
  width: 30px;
  height: 30px;
  position: absolute;
  top: -5px;
  right: -5px;
  z-index: 100;
}
</style>